import { Typography } from '@pmi.web/react-common';
import { useTranslation } from 'react-i18next';

import { HelpSlide } from '../HelpSlide';

export function SlideIntro() {
  const { t } = useTranslation();

  return (
    <HelpSlide>
      <svg
        viewBox="0 0 256 256"
        height="62px"
        width="62px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M240,194H230V98.67A14,14,0,0,0,223.77,87l-88-58.66a14,14,0,0,0-15.54,0L32.23,87A14,14,0,0,0,26,98.67V194H16a6,6,0,0,0,0,12H240a6,6,0,0,0,0-12ZM38,98.67A2,2,0,0,1,38.89,97l88-58.67a2,2,0,0,1,2.22,0l88,58.67a2,2,0,0,1,.89,1.66V194H190V136a6,6,0,0,0-6-6H72a6,6,0,0,0-6,6v58H38ZM178,142v20H134V142Zm-56,20H78V142h44ZM78,174h44v20H78Zm56,0h44v20H134Z"></path>
      </svg>

      <div
        style={{
          marginTop: 'var(--pmi-spacing-md)',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 'var(--pmi-spacing-xs)',
        }}
      >
        <Typography variant="h1">{t('Virtual Warehouse')}</Typography>
        <span
          style={{
            backgroundColor: 'var(--pmi-color-primary)',
            color: 'white',
            borderRadius: '4px',
            padding: '4px',
            fontSize: '10px',
            fontWeight: 'bold',
            lineHeight: '10px',
          }}
        >
          NEW
        </span>
      </div>
      <div
        style={{
          marginTop: 'var(--pmi-spacing-xs)',
        }}
      >
        <Typography variant="p">
          {t(
            'Sell products with no upfront costs, no shipping hassle and start earning instantly, with a commitment to sell within 7 days.',
          )}
        </Typography>
      </div>
    </HelpSlide>
  );
}
